import { render, staticRenderFns } from "./ImportUrgentComponent.vue?vue&type=template&id=21278023&scoped=true&"
import script from "./ImportUrgentComponent.vue?vue&type=script&lang=js&"
export * from "./ImportUrgentComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImportUrgentComponent.vue?vue&type=style&index=0&id=21278023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21278023",
  null
  
)

export default component.exports